import { useLoaderData } from 'react-router-typesafe'
import { Navigate } from 'react-router'
import { clientSiteSupportHandlerRouteLoader } from '@/routes/clients/client/sites/ClientSiteSupportHandler.route'

const ClientSiteSupportHandler = () => {
  const { getAzienda } = useLoaderData<typeof clientSiteSupportHandlerRouteLoader>()
  let supportId = getAzienda.data.sede_principale?.assistenze?.[0]?.id
  if (supportId === undefined) {
    getAzienda.data.sedi?.forEach((sede) => {
      const support = sede.assistenze?.[0]?.id
      if (support && supportId === undefined) {
        supportId = support
      }
    })
  }
  return supportId ? (
    <Navigate to={`${supportId}`} replace={false} />
  ) : (
    <div>
      <h3>Nessun contratto di assistenza selezionato</h3>
      <h5>Non è stato trovata nessuna sede principale</h5>
    </div>
  )
}

export default ClientSiteSupportHandler
